/*@flow*/
import dasherize from 'underscore.string/dasherize';

function escapeRegExp(string) {
  return string.replace(/[&.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
export default (name: string) =>
  dasherize(
    escapeRegExp(name.replace('&', '').replace(/\s+/, ' '))
      .replace(/(^\d)+/g, '')
      .toLowerCase()
  );
